var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dorms)?_c('DormList',{attrs:{"dorms":_vm.dorms}}):_vm._e(),(_vm.popupDorms && _vm.popupDorms.length > 0)?_c('FixedPopup',{attrs:{"dorms":_vm.popupDorms}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }